module.exports = __webpack_public_path__ + "img/role01.c7b2f880.png";